import { render, staticRenderFns } from "./MediaPage.vue?vue&type=template&id=5468bb10&scoped=true"
import script from "./MediaPage.vue?vue&type=script&lang=js"
export * from "./MediaPage.vue?vue&type=script&lang=js"
import style0 from "./MediaPage.vue?vue&type=style&index=0&id=5468bb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468bb10",
  null
  
)

export default component.exports